import { useState } from 'react';
import { useInfiniteQuery } from 'react-query';
import { getDisputeList, ListResponse } from '../justifi.api';

export const useInfiniteGetJustifiDisputeList = ({
  locationId,
}: {
  locationId: string;
}) => {
  const [pageConfig, setPageConfig] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const { data, fetchNextPage, fetchPreviousPage, isLoading, refetch } = useInfiniteQuery(
    {
      queryKey: [locationId, 'justifi', 'dispute-list', pageConfig.pageSize],
      queryFn: async ({ pageParam }) =>
        getDisputeList({
          locationId,
          pageSize: pageConfig.pageSize,
          pageToken: pageParam,
        }),
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!locationId,
      getNextPageParam: (dispute: ListResponse) => dispute?.nextPageToken,
    }
  );

  const hasNextPage = !!data?.pages[pageConfig.pageNumber - 1]?.nextPageToken;
  const hasPreviousPage = pageConfig.pageNumber !== 1;

  return {
    data,
    fetchNextPage,
    fetchPreviousPage,
    loading: isLoading,
    hasNextPage,
    hasPreviousPage,
    pageConfig,
    setPageConfig,
    refetch,
  };
};
